import { worldViewerWindow } from './const';
import { getVideoRecorder, setVideoRecorder, getRecordedVideoBlobURL, setRecordedVideoBlobURL, getVideoRecorderExtension, setVideoRecorderExtension, getAudioList, getVideoRecordCanvas, setVideoRecordCanvas, getVideoRecordContext, setVideoRecordContext } from './logics/dataOps';
import { getMainCanvasDOMElement } from './logics/domOps';
/**
 * C++から参照あり
 */ worldViewerWindow.hel_start_video_record = (width, height)=>{
    // 以前のBlobがまだ存在する場合はまず解放する
    var prevBlob = getRecordedVideoBlobURL();
    if (prevBlob !== undefined && prevBlob !== null) {
        URL.revokeObjectURL(prevBlob);
        setRecordedVideoBlobURL(null);
    }
    //
    var recorder = getVideoRecorder();
    if (recorder === undefined || recorder === null) {
        // レコード用のキャンバスを作成
        const RecordCanvas = document.createElement('canvas');
        RecordCanvas.style.visibility = 'hidden';
        RecordCanvas.width = width;
        RecordCanvas.height = height;
        setVideoRecordCanvas(RecordCanvas);
        var RecordCtx = RecordCanvas.getContext('2d');
        if (RecordCtx !== null) {
        // RecordCtx.imageSmoothingEnabled = false;
        }
        setVideoRecordContext(RecordCtx);
        // ビデオレコーダーを作成
        recorder = createRecoreder();
        // レコード開始
        recorder.start();
        setVideoRecorder(recorder);
    }
};
const createRecoreder = ()=>{
    //
    var recorder = null;
    var supportedType = null;
    var extension = null;
    let recordedStream = new MediaStream();
    // レコードタイプと拡張子を選定
    if (MediaRecorder.isTypeSupported('video/webm;codecs=vp9,opus')) {
        supportedType = 'video/webm;codecs=vp9,opus';
        extension = 'webm';
    } else if (MediaRecorder.isTypeSupported('video/webm;codecs=vp8,opus')) {
        supportedType = 'video/webm;codecs=vp8,opus';
        extension = 'webm';
    } else if (MediaRecorder.isTypeSupported('video/mp4;codecs=avc1')) {
        supportedType = 'video/mp4;codecs=avc1';
        extension = 'mp4';
    }
    // キャンバストラックをストリームに追加
    const RecordCanvas = getVideoRecordCanvas();
    if (RecordCanvas !== undefined && RecordCanvas !== null) {
        let CanvasStream = RecordCanvas.captureStream();
        const videoTrack = CanvasStream.getVideoTracks();
        recordedStream.addTrack(videoTrack[0]);
    }
    // オーディオトラックをストリームに追加
    var audioList = getAudioList();
    if (audioList !== undefined && audioList !== null) {
        audioList.forEach((element)=>{
            if (element !== null) {
                if (element.isPlaying() && element.getType() == 0) {
                    var context = element.getContext();
                    var gainNode = element.getGainNode();
                    if (context !== undefined && gainNode !== undefined) {
                        let dest = context.createMediaStreamDestination();
                        gainNode.connect(dest);
                        let audioStream = dest.stream;
                        const audioTrack = audioStream.getTracks();
                        recordedStream.addTrack(audioTrack[0]);
                    }
                }
            }
        });
    }
    // レコーダーを作成
    if (supportedType !== null && supportedType != "") {
        recorder = new MediaRecorder(recordedStream, {
            mimeType: supportedType
        });
    }
    // レコード完了後のイベントを追加
    if (recorder) {
        recorder.ondataavailable = (e)=>{
            let videoBlob = new Blob([
                e.data
            ], {
                type: e.data.type
            });
            const BlobURL = window.URL.createObjectURL(videoBlob);
            setRecordedVideoBlobURL(BlobURL);
        };
    }
    //
    setVideoRecorderExtension(extension);
    return recorder;
};
/**
 * C++から参照あり
 */ worldViewerWindow.hel_request_frame_for_video_record = ()=>{
    var recorder = getVideoRecorder();
    if (recorder !== undefined && recorder !== null) {
        var videoTrack = recorder.stream.getVideoTracks()[0];
        const RecordCanvas = getVideoRecordCanvas();
        const MainCanvas = getMainCanvasDOMElement();
        if (videoTrack !== undefined && videoTrack !== null && RecordCanvas !== undefined && RecordCanvas !== null && MainCanvas !== undefined && MainCanvas !== null) {
            const ctx = getVideoRecordContext();
            ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(MainCanvas, 0, 0);
        // videoTrack.requestFrame();
        }
    }
};
/**
 * C++から参照あり
 */ worldViewerWindow.hel_stop_video_record = ()=>{
    var recorder = getVideoRecorder();
    if (recorder !== undefined && recorder !== null) {
        recorder.stop();
        // レコード関連のリソースを解放する
        let tracks = recorder.stream.getTracks();
        tracks.forEach((track)=>{
            track.stop();
            recorder.stream.removeTrack(track);
        });
        setVideoRecorder(null);
        const RecordCanvas = getVideoRecordCanvas();
        if (RecordCanvas !== undefined && RecordCanvas !== null) {
            RecordCanvas.remove();
            setVideoRecordCanvas(null);
            setVideoRecordContext(null);
        }
    }
};
/**
 * C++から参照あり
 */ worldViewerWindow.hel_open_recorded_video_preview = ()=>{
    const BlobURL = getRecordedVideoBlobURL();
    if (BlobURL !== undefined && BlobURL !== null) {
        if (worldViewerWindow.hel_isiPhone()) {
            window.location.href = BlobURL;
        } else {
            window.open(BlobURL, '_blank');
        }
    }
};
/**
 * C++から参照あり
 */ worldViewerWindow.hel_save_recorded_video = ()=>{
    const BlobURL = getRecordedVideoBlobURL();
    const extension = getVideoRecorderExtension();
    if (BlobURL !== undefined && BlobURL !== null && extension !== undefined && extension !== null) {
        // 保存ダイアログを開く
        const a = document.createElement("a");
        a.href = BlobURL;
        const today = new Date();
        a.download = "" + today.getFullYear() + ("00" + (today.getMonth() + 1)).slice(-2) + ("00" + today.getDate()).slice(-2) + "_" + ("00" + today.getHours()).slice(-2) + ("00" + today.getMinutes()).slice(-2) + ("00" + today.getSeconds()).slice(-2) + "." + extension;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
};
/**
 * C++から参照有り
 */ worldViewerWindow.hel_get_VideoRecordCanvas = ()=>{
    return getVideoRecordCanvas();
};
/**
 * C++から参照有り
 */ worldViewerWindow.hel_get_VideoRecordContext = ()=>{
    return getVideoRecordContext();
};
